import { useTranslation } from 'react-i18next';

import type { Invoice } from '~/api/invoices/types';

import { Dialog } from '~/components';
import { AdvantageSimulationDialog } from '~/features/documents';
import { useIntl } from '~/hooks/useIntl';
import { cellLinkStyle, desktopTruncateStyle } from '~/styles/utilities.css';
import { clsx } from '~/styles/utils';

import { advantageStyle } from './invoiceCell.css';

type Props = {
  advantage: number;
  invoice: Invoice;
};

export const InvoiceAdvantageCell = ({ advantage, invoice }: Props) => {
  const { formatCurrency } = useIntl();
  const { t } = useTranslation(['invoices']);

  return (
    <Dialog.Root>
      <Dialog.Trigger
        aria-label={t('invoices:overview.rowActions.advantage')}
        className={clsx(cellLinkStyle, desktopTruncateStyle, advantageStyle)}
      >
        {formatCurrency(advantage)}
      </Dialog.Trigger>

      <AdvantageSimulationDialog calculationData={invoice.calculationData} />
    </Dialog.Root>
  );
};
